//DatePicker Element
import { CartNoteDialog } from '//greenox.de/cdn/shop/t/41/assets/theme.js';
import { CartNote } from '//greenox.de/cdn/shop/t/41/assets/theme.js';

class CustomCartNoteDialog extends CartNoteDialog {
  connectedCallback() {
    super.connectedCallback();
    
    // Warte bis der Dialog vollständig initialisiert ist, bevor wir Event Listener hinzufügen
    setTimeout(() => {
      this.addEventListener('toggle', function (event) {
        if (this.open) {
          console.log('Dialog geöffnet');
          // Warte kurz, bevor wir den Datepicker öffnen, damit der Dialog Zeit hat sich zu öffnen
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent('cart:openPicker', {
                bubbles: true,
              })
            );
          }, 100);
        }
      });
    }, 0);
  }
}

class DateNote extends CartNote {
  connectedCallback() {
    var datePicker = this.querySelector('#datePicker');
    const elem = datePicker;
    const datepicker = new Datepicker(elem, {
      daysOfWeekDisabled: [0, 1, 2, 6],
      minDate: new Date(elem.getAttribute('min')),
      autohide: true,
      dateDelimiter: '-',
    });

    this.closest('form')
      .querySelector('button[data-cart-date]')
      .addEventListener('click', function (event) {
        const shopifyDate = datePicker.value;
        
        if (!shopifyDate) {
          console.warn('Kein Datum ausgewählt');
          return;
        }
        
        let attributes = { attributes: { DeliveryDate: shopifyDate } };
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(attributes),
        })
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            console.log('Datum gespeichert:', cart.attributes.DeliveryDate);
            
            // Speichere das DeliveryDate auch in localStorage als Backup
            if (cart.attributes.DeliveryDate) {
              localStorage.setItem('greenox_delivery_date', cart.attributes.DeliveryDate);
            }
            
            // Aktualisiere das hidden input im Checkout-Formular
            const form = document.querySelector('cart-drawer form');
            if (form) {
              let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
              
              if (!dateInput && cart.attributes.DeliveryDate) {
                dateInput = document.createElement('input');
                dateInput.type = 'hidden';
                dateInput.name = 'attributes[DeliveryDate]';
                form.appendChild(dateInput);
              }
              
              if (dateInput) {
                dateInput.value = cart.attributes.DeliveryDate;
              }
            }
            
            // Triggere cart:refresh Event
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { deliveryDate: cart.attributes.DeliveryDate }
              })
            );
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      });

    document.addEventListener('cart:openPicker', function () {
      datepicker.show();
    });
  }
}

// Funktion um die Datumsanzeige zu aktualisieren
function updateDeliveryDateDisplay(deliveryDate) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    console.log('Cart-Drawer nicht gefunden');
    return;
  }
  
  // Warte bis der Cart-Drawer vollständig geladen ist
  const waitForElement = setInterval(() => {
    const dateDisplayArea = cartDrawer.querySelector('.v-stack.gap-0\\.5.justify-items-start');
    
    if (!dateDisplayArea) {
      console.log('Date Display Area noch nicht geladen...');
      return;
    }
    
    clearInterval(waitForElement);
    
    console.log('Aktualisiere Datumsanzeige mit:', deliveryDate);
    
    // Suche nach den spezifischen Elementen
    let noDateText = null;
    let addDateButton = null;
    let dateDisplayText = null;
    let editButton = null;
    
    // Durchsuche alle Kinder nach den relevanten Elementen
    const children = dateDisplayArea.querySelectorAll('*');
    children.forEach(child => {
      const text = child.textContent || '';
      
      if (text.includes('Wunschlieferdatum') && !child.hasAttribute('aria-controls')) {
        noDateText = child;
      }
      
      if (child.hasAttribute('aria-controls') && child.getAttribute('aria-controls').includes('--date')) {
        if (text.includes('wählen') || text.includes('hinzufügen')) {
          addDateButton = child;
        } else if (text.includes('ändern') || text.includes('bearbeiten')) {
          editButton = child;
        }
      }
      
      if (child.querySelector('b') && text.includes(deliveryDate)) {
        dateDisplayText = child;
      }
    });
    
    if (deliveryDate) {
      // Verstecke "Kein Datum gewählt" Text
      if (noDateText) {
        noDateText.style.display = 'none';
      }
      
      // Verstecke "Datum hinzufügen" Button
      if (addDateButton) {
        addDateButton.style.display = 'none';
      }
      
      // Zeige oder erstelle Datumsanzeige
      if (!dateDisplayText) {
        dateDisplayText = document.createElement('div');
        dateDisplayText.innerHTML = `Gewünschtes Lieferdatum: <b>${deliveryDate}</b>`;
        dateDisplayText.className = 'delivery-date-text';
        dateDisplayArea.appendChild(dateDisplayText);
      } else {
        dateDisplayText.style.display = 'block';
        dateDisplayText.innerHTML = `Gewünschtes Lieferdatum: <b>${deliveryDate}</b>`;
      }
      
      // Zeige oder erstelle "Bearbeiten" Button
      if (!editButton) {
        // Versuche den Button aus der Liquid-Datei zu finden
        const existingEditButton = cartDrawer.querySelector('button[aria-controls*="--date"].link');
        if (existingEditButton && (existingEditButton.textContent.includes('ändern') || existingEditButton.textContent.includes('bearbeiten'))) {
          editButton = existingEditButton;
          editButton.style.display = 'block';
        } else {
          // Erstelle einen neuen Button nur wenn keiner existiert
          editButton = document.createElement('button');
          editButton.className = 'link';
          editButton.textContent = 'Lieferdatum ändern';
          const dialogId = addDateButton ? addDateButton.getAttribute('aria-controls') : cartDrawer.querySelector('cart-note-dialog-date')?.id || 'cart-note-date';
          editButton.setAttribute('aria-controls', dialogId);
          dateDisplayArea.appendChild(editButton);
        }
      } else {
        editButton.style.display = 'block';
      }
    }
  }, 100);
  
  // Timeout nach 3 Sekunden
  setTimeout(() => clearInterval(waitForElement), 3000);
}

// Event Listener für cart:refresh
document.addEventListener('cart:refresh', function(event) {
  console.log('Cart wurde aktualisiert, warte auf Neuladen...');
  
  // Prüfe, ob ein Dialog geöffnet ist - wenn ja, warte bis er geschlossen ist
  const openDialog = document.querySelector('cart-note-dialog-date[open]');
  if (openDialog) {
    console.log('Dialog ist geöffnet, warte bis er geschlossen ist...');
    const checkDialogClosed = setInterval(() => {
      if (!openDialog.hasAttribute('open')) {
        clearInterval(checkDialogClosed);
        // Führe die Aktualisierung nach dem Schließen des Dialogs aus
        setTimeout(() => {
          performCartRefresh();
        }, 300);
      }
    }, 100);
    
    // Timeout nach 5 Sekunden, falls der Dialog nicht geschlossen wird
    setTimeout(() => {
      clearInterval(checkDialogClosed);
      performCartRefresh();
    }, 5000);
  } else {
    performCartRefresh();
  }
});

// Funktion zum Ausführen des Cart-Refreshs
function performCartRefresh() {
  // Warte etwas länger, da der Cart-Drawer neu geladen wird
  setTimeout(() => {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log('Cart nach Refresh:', cart);
        if (cart.attributes && cart.attributes.DeliveryDate) {
          // Speichere auch in localStorage als Backup
          localStorage.setItem('greenox_delivery_date', cart.attributes.DeliveryDate);
          
          // Aktualisiere das hidden input im Checkout-Formular
          const form = document.querySelector('cart-drawer form');
          if (form) {
            let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
            
            if (!dateInput) {
              dateInput = document.createElement('input');
              dateInput.type = 'hidden';
              dateInput.name = 'attributes[DeliveryDate]';
              form.appendChild(dateInput);
            }
            
            dateInput.value = cart.attributes.DeliveryDate;
          }
          
          // Aktualisiere die Anzeige nur, wenn kein Dialog geöffnet ist
          const openDialog = document.querySelector('cart-note-dialog-date[open]');
          if (!openDialog) {
            updateDeliveryDateDisplay(cart.attributes.DeliveryDate);
          }
        } else {
          // Wenn das DeliveryDate im Cart fehlt, versuche es aus localStorage wiederherzustellen
          const storedDate = localStorage.getItem('greenox_delivery_date');
          if (storedDate) {
            console.log('DeliveryDate fehlt nach Refresh, stelle aus localStorage wieder her');
            restoreDeliveryDateFromStorage();
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, 500); // Erhöhe das Timeout, damit der Cart-Drawer Zeit hat neu zu laden
}

// Event Listener für cart-drawer:refreshed - wird ausgelöst, wenn der Cart-Drawer neu geladen wurde
document.addEventListener('cart-drawer:refreshed', function() {
  console.log('Cart-Drawer wurde neu geladen, aktualisiere DeliveryDate...');
  
  // Warte kurz, damit der Cart-Drawer vollständig geladen ist
  setTimeout(() => {
    const storedDate = localStorage.getItem('greenox_delivery_date');
    if (storedDate) {
      // Prüfe, ob das DeliveryDate im Cart vorhanden ist
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          // Stelle sicher, dass das hidden input im Formular vorhanden ist
          const form = document.querySelector('cart-drawer form');
          if (form) {
            let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
            
            if (!dateInput) {
              dateInput = document.createElement('input');
              dateInput.type = 'hidden';
              dateInput.name = 'attributes[DeliveryDate]';
              form.appendChild(dateInput);
            }
            
            // Verwende das Datum aus dem Cart, falls vorhanden, sonst aus localStorage
            const deliveryDate = (cart.attributes && cart.attributes.DeliveryDate) ? cart.attributes.DeliveryDate : storedDate;
            dateInput.value = deliveryDate;
            
            // Wenn das DeliveryDate im Cart fehlt, stelle es wieder her
            if (!cart.attributes || !cart.attributes.DeliveryDate) {
              restoreDeliveryDateFromStorage();
            } else {
              // Aktualisiere die Anzeige
              updateDeliveryDateDisplay(deliveryDate);
            }
          }
        })
        .catch((error) => {
          console.error('Error beim Aktualisieren nach Cart-Drawer Refresh:', error);
        });
    }
  }, 200);
});

// Funktion zum Wiederherstellen des DeliveryDate aus localStorage
function restoreDeliveryDateFromStorage() {
  const storedDate = localStorage.getItem('greenox_delivery_date');
  if (!storedDate) {
    return Promise.resolve(null);
  }
  
  return fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      // Prüfe, ob das DeliveryDate im Cart fehlt, aber in localStorage vorhanden ist
      if (!cart.attributes || !cart.attributes.DeliveryDate) {
        console.log('DeliveryDate fehlt im Cart, stelle aus localStorage wieder her:', storedDate);
        
        // Stelle das DeliveryDate wieder her
        let attributes = { attributes: { DeliveryDate: storedDate } };
        
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(attributes),
        })
          .then((response) => response.json())
          .then((updatedCart) => {
            console.log('DeliveryDate wiederhergestellt:', updatedCart.attributes.DeliveryDate);
            
            // Aktualisiere das hidden input im Checkout-Formular
            const form = document.querySelector('cart-drawer form');
            if (form) {
              let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
              
              if (!dateInput) {
                dateInput = document.createElement('input');
                dateInput.type = 'hidden';
                dateInput.name = 'attributes[DeliveryDate]';
                form.appendChild(dateInput);
              }
              
              dateInput.value = updatedCart.attributes.DeliveryDate;
            }
            
            // Aktualisiere die Anzeige
            updateDeliveryDateDisplay(updatedCart.attributes.DeliveryDate);
            
            return updatedCart.attributes.DeliveryDate;
          });
      } else {
        // DeliveryDate ist bereits im Cart vorhanden
        console.log('DeliveryDate bereits im Cart vorhanden:', cart.attributes.DeliveryDate);
        
        // Aktualisiere das hidden input im Checkout-Formular
        const form = document.querySelector('cart-drawer form');
        if (form) {
          let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
          
          if (!dateInput) {
            dateInput = document.createElement('input');
            dateInput.type = 'hidden';
            dateInput.name = 'attributes[DeliveryDate]';
            form.appendChild(dateInput);
          }
          
          dateInput.value = cart.attributes.DeliveryDate;
        }
        
        // Aktualisiere die Anzeige
        updateDeliveryDateDisplay(cart.attributes.DeliveryDate);
        
        return cart.attributes.DeliveryDate;
      }
    })
    .catch((error) => {
      console.error('Error beim Wiederherstellen:', error);
      return null;
    });
}

// Initialisierung beim Laden
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    // Versuche zuerst, das DeliveryDate aus localStorage wiederherzustellen
    restoreDeliveryDateFromStorage()
      .then((deliveryDate) => {
        if (!deliveryDate) {
          // Wenn kein gespeichertes Datum vorhanden ist, prüfe den Cart
          return fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((response) => response.json())
            .then((cart) => {
              console.log('Cart beim Laden:', cart);
              if (cart.attributes && cart.attributes.DeliveryDate) {
                console.log('Gespeichertes Lieferdatum gefunden:', cart.attributes.DeliveryDate);
                // Speichere auch in localStorage als Backup
                localStorage.setItem('greenox_delivery_date', cart.attributes.DeliveryDate);
                
                // Aktualisiere das hidden input im Checkout-Formular
                const form = document.querySelector('cart-drawer form');
                if (form) {
                  let dateInput = form.querySelector('input[name="attributes[DeliveryDate]"]');
                  
                  if (!dateInput) {
                    dateInput = document.createElement('input');
                    dateInput.type = 'hidden';
                    dateInput.name = 'attributes[DeliveryDate]';
                    form.appendChild(dateInput);
                  }
                  
                  dateInput.value = cart.attributes.DeliveryDate;
                }
                
                updateDeliveryDateDisplay(cart.attributes.DeliveryDate);
              }
            });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, 300);
});

window.customElements.define('date-note', DateNote);
window.customElements.define('cart-note-dialog-date', CustomCartNoteDialog);

// Rest des Codes...
class secondarynav extends HTMLElement {
  connectedCallback() {
    this.parent = this.closest('x-header');
    this.primaryNav = this.parent.querySelector("nav[extends='secondary-nav']");
    this.primaryNavItems = this.primaryNav.querySelectorAll('li');

    this.secondaryNavItems = this.querySelectorAll('[secondary-nav-target]');
    this.activeNav = localStorage.getItem('greenox-header-active');

    if (this.activeNav ?? false) {
      this.secondaryNavItems.forEach((navigation) => {
        if (navigation.getAttribute('secondary-nav-target') === this.activeNav) {
          navigation.classList.remove('hidden');
        } else {
          navigation.classList.add('hidden');
        }
      });
    }

    this.primaryNavItems.forEach((item) => {
      item.addEventListener('mouseover', (event) => this.handleHover(event));
      item.addEventListener('click', (event) => this.handleClick(event));
    });
  }

  handleClick = (event) => {
    let _this = event.currentTarget;
    this.secondaryNavItems.forEach((navItem) => {
      if (navItem.getAttribute('secondary-nav-target') === _this.getAttribute('secondary-nav-target')) {
        navItem.classList.remove('hidden');
        localStorage.setItem('greenox-header-active', _this.getAttribute('secondary-nav-target'));
      } else {
        navItem.classList.add('hidden');
      }
    });
  };

  handleHover = (event) => {
    let _this = event.currentTarget;
    this.secondaryNavItems.forEach((navItem) => {
      if (navItem.getAttribute('secondary-nav-target') === _this.getAttribute('secondary-nav-target')) {
        navItem.classList.remove('hidden');
      } else {
        navItem.classList.add('hidden');
      }
    });
  };
}

let datePicker = document.querySelector('#datePicker');
if (datePicker) {
  datePicker.addEventListener('change', function (event) {
    console.log('Change event triggered');
    console.log(event);
  });
}

/*Init Custom Elements*/
window.customElements.define('secondary-nav', secondarynav);